var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "otherinformation"
  }, [(_vm.closeTrip == false) ? _c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("Start Trip")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Back to Create Trip"
    },
    on: {
      "click": _vm.showCreateTrip
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "style": "font-size:18px"
    }
  })])])])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.Loader
    },
    on: {
      "update:active": function($event) {
        _vm.Loader = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "8%"
    }
  }, [_vm._v("Trip ID:")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "12%"
    }
  }, [_vm._v(_vm._s(_vm.parentOBJ.tmstripid))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "8%"
    }
  }, [_vm._v("Trip Status:")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "12%"
    }
  }, [_vm._v(_vm._s(_vm.tripStatus == 'created' ? 'Created' : _vm.tripStatus == 'start' ? 'Start' : _vm.tripStatus == 'closed' ? 'Closed' : ''))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "8%"
    }
  }, [_vm._v("Vehicle:")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "12%"
    }
  }, [_vm._v(_vm._s(_vm.parentOBJ.vehicleNumber))]), _vm._v(" "), _c('th', [_vm._v("Vehicle Start ODO reading(km)")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleODOReading),
      expression: "vehicleODOReading"
    }],
    class: {
      'showValue': _vm.ODOhidden == true,
      'showValueNone': _vm.ODOhidden == false,
      'form-control': true
    },
    attrs: {
      "type": "number",
      "min": "0",
      "name": "vehicleODOReading",
      "id": "vehicleODOReading"
    },
    domProps: {
      "value": (_vm.vehicleODOReading)
    },
    on: {
      "keyup": _vm.checkODOKm,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vehicleODOReading = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.ODOErr))])], 1)])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row position"
  }, [_c('div', {
    staticStyle: {
      "margin-left": "48rem",
      "margin-top": "-13px"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "reset",
      "disabled": _vm.tripStatus == 'start' || _vm.ODOErr != ''
    },
    on: {
      "click": _vm.startTrip
    }
  }, [_vm._v("Start Trip")]), _vm._v(" "), _c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "reset",
      "disabled": _vm.tripStatus != 'start'
    },
    on: {
      "click": _vm.PrintTripSheet
    }
  }, [_vm._v("Print Trip Sheet")])])]), _vm._v(" "), _c('div', [_c('br'), _vm._v(" "), _c('b-tabs', {
    staticClass: "tab-content1 tab-header1",
    attrs: {
      "content-class": "mt-2"
    }
  }, [_c('b-tab', {
    staticClass: "tab-content1 tab-header1",
    attrs: {
      "title": "First Mile",
      "title-link-class": _vm.linkClass(0)
    },
    on: {
      "click": function($event) {
        _vm.changeTab('firstmile')
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isAWBLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isAWBLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v(" FM AWB")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "18%"
    }
  }, [_vm._v("Documents to be scanned:")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.firstmileAWBItem.length - _vm.AWBScanned) + "  "), _c('i', {
    staticClass: "fa fa-refresh",
    staticStyle: {
      "font-size": "19px"
    },
    on: {
      "click": function($event) {
        _vm.refreshData()
      }
    }
  })]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("AWB:")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "12%"
    }
  }, [_vm._v(_vm._s(_vm.Scandocument))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "18%"
    }
  }, [_vm._v("Scanned document count:")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "8%"
    }
  }, [_vm._v(_vm._s(_vm.AWBScanned) + "/" + _vm._s(_vm.firstmileAWBItem.length))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "11%"
    }
  }, [_vm._v("Scan Document")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Scandocument),
      expression: "Scandocument"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "Scandocument",
      "id": "Scandocument"
    },
    domProps: {
      "value": (_vm.Scandocument)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.Scandocument = $event.target.value
      }, _vm.scanAWB]
    }
  })])], 1)])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('th', [_vm._v("Sr.No")]), _vm._v(" "), _c('th', [_vm._v("AWB")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Number of MPS")]), _vm._v(" "), _c('th', [_vm._v("Scanned Status(Y or N)")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.firstmileAWBItem), function(data, index) {
    return [_c('tr', {
      class: {
        'rowtype1': data.documentscanned
      },
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awb))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.clientname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.numberofmps))]), _vm._v(" "), (data.documentscanned) ? _c('td', [_vm._v("Y")]) : _vm._e(), _vm._v(" "), (!data.documentscanned) ? _c('td', [_vm._v("N")]) : _vm._e()])]
  }), _vm._v(" "), (_vm.firstmileAWBItem.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])])]), _vm._v(" "), _c('br')])])])], 1), _vm._v(" "), _c('b-tab', {
    staticClass: "tab-content1 tab-header1",
    attrs: {
      "title": "Last Mile",
      "title-link-class": _vm.linkClass(1)
    },
    on: {
      "click": function($event) {
        _vm.changeTab('lastmile')
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isAWBLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isAWBLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.expanded == false) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Expand All"
    },
    on: {
      "click": _vm.expandAll
    }
  }, [_vm._v("\n                Expand All "), _c('i', {
    staticClass: "fa fa-plus-circle"
  })]) : _vm._e(), _vm._v(" "), (_vm.expanded == true) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Collapse All"
    },
    on: {
      "click": _vm.collapseAll
    }
  }, [_vm._v("\n                Collapse All "), _c('i', {
    staticClass: "fa fa-minus-circle"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[1]),
      expression: "accordianTab[1]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "AWBDocument",
      "id": "chck1"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[1]) ? _vm._i(_vm.accordianTab[1], null) > -1 : (_vm.accordianTab[1])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(1)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck1"
    }
  }, [_vm._v("AWB Document")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('legend', [_vm._v(" LM AWB")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "13%"
    }
  }, [_vm._v("Documents to be scanned:")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.LastmileAWBItem.length - _vm.AWBScanned) + "  "), _c('i', {
    staticClass: "fa fa-refresh",
    staticStyle: {
      "font-size": "19px"
    }
  })]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("AWB:")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "8%"
    }
  }, [_vm._v(_vm._s(_vm.Scandocument))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "18%"
    }
  }, [_vm._v("Scanned document count:")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "8%"
    }
  }, [_vm._v(_vm._s(_vm.AWBScanned) + "/" + _vm._s(_vm.LastmileAWBItem.length))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "8%"
    }
  }, [_vm._v("Scan Document")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Scandocument),
      expression: "Scandocument"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "Scandocument",
      "id": "Scandocument"
    },
    domProps: {
      "value": (_vm.Scandocument)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.Scandocument = $event.target.value
      }, _vm.scanAWB]
    }
  })])], 1)])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('th', [_vm._v("Sr.No")]), _vm._v(" "), _c('th', [_vm._v("AWB")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Number of MPS")]), _vm._v(" "), _c('th', [_vm._v("Scanned Status(Y or N)")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.LastmileAWBItem), function(data, index) {
    return [_c('tr', {
      class: {
        'rowtype1': data.documentscanned,
        'rowtype2': data.isdocumentshort
      },
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awb))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.clientname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.numberofmps))]), _vm._v(" "), (data.documentscanned) ? _c('td', [_vm._v("Y")]) : _vm._e(), _vm._v(" "), (!data.documentscanned) ? _c('td', [_vm._v("N")]) : _vm._e(), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "-btn btn-danger",
      attrs: {
        "type": "button",
        "disabled": data.documentscanned == 1 || data.isdocumentshort == 1,
        "title": "Mark Short"
      },
      on: {
        "click": function($event) {
          _vm.MarkShortConfirmation(data)
        }
      }
    }, [_vm._v("\n                                  Mark Short")])])])]
  }), _vm._v(" "), (_vm.LastmileAWBItem.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('br')])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[2]),
      expression: "accordianTab[2]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "MPS",
      "id": "chck2"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[2]) ? _vm._i(_vm.accordianTab[2], null) > -1 : (_vm.accordianTab[2])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(2)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[2] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[2] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 2, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck2"
    }
  }, [_vm._v("MPS")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Scan Shipment Type:")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentType),
      expression: "shipmentType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "AWB",
      "value": "1",
      "disabled": _vm.defaultscanflag != 1,
      "name": "shipmentType"
    },
    domProps: {
      "checked": _vm._q(_vm.shipmentType, "1")
    },
    on: {
      "__c": function($event) {
        _vm.shipmentType = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "AWB"
    }
  }, [_vm._v("AWB ")]), _vm._v("     \n                            "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentType),
      expression: "shipmentType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "MPS",
      "value": "2",
      "disabled": _vm.defaultscanflag != 2,
      "name": "shipmentType"
    },
    domProps: {
      "checked": _vm._q(_vm.shipmentType, "2")
    },
    on: {
      "__c": function($event) {
        _vm.shipmentType = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "MPS"
    }
  }, [_vm._v("MPS")]), _vm._v("     \n                          ")])])], 1), _vm._v(" "), _c('th', {
    attrs: {
      "width": "13%"
    }
  }, [_vm._v("MPS to be loaded:")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.lastmileMPSItem.length))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("MPS already loaded:")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.MPSScanned))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "12%"
    }
  }, [_vm._v("Scan AWB/ MPS")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ScanAWB),
      expression: "ScanAWB"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "ScanAWB",
      "id": "ScanAWB"
    },
    domProps: {
      "value": (_vm.ScanAWB)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.ScanAWB = $event.target.value
      }, _vm.scanMPS]
    }
  })])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("Scanned AWB/ MPS")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('label', [_c('b', [_vm._v("MPS:" + _vm._s(_vm.shipmentType == 2 ? _vm.ScanAWB : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('label', [_c('b', [_vm._v("AWB: " + _vm._s(_vm.shipmentType == 1 ? _vm.ScanAWB : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('label', [_c('b', [_vm._v("Scanned MPS count in AWB: " + _vm._s(_vm.MPSScanned) + "/" + _vm._s(_vm.tobescanned))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "4rem"
    }
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.lastmileMPSItem.length == 0
    },
    on: {
      "click": _vm.openDeps
    }
  }, [_vm._v("DEPS")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('th', [_vm._v("Sr.No")]), _vm._v(" "), _c('th', [_vm._v("MPS")]), _vm._v(" "), _c('th', [_vm._v("AWB")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("MPS Physical Weight(kg)")]), _vm._v(" "), _c('th', [_vm._v("Scanned Status(Y or N)")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.temparr), function(data, index) {
    return [_c('tr', {
      class: {
        'rowtype1': data.mpsscanned,
        'rowtype2': data.ismpsshort || data.isdeps
      },
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.mps))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awb))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.clientname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.totalphysicalwt))]), _vm._v(" "), (data.mpsscanned) ? _c('td', [_vm._v("Y")]) : _vm._e(), _vm._v(" "), (!data.mpsscanned) ? _c('td', [_vm._v("N")]) : _vm._e()])]
  }), _vm._v(" "), (_vm.lastmileMPSItem.length > 100) ? [(_vm.lastmileMPSItem && _vm.lastmileMPSItem.length > 100) ? _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#20a8d8"
    },
    attrs: {
      "title": "Click to open list of MPS"
    },
    on: {
      "click": function($event) {
        _vm.displayMPS(_vm.lastmileMPSItem)
      }
    }
  }, [_vm._v("...+" + _vm._s(_vm.lastmileMPSItem ? _vm.lastmileMPSItem.length - 100 : '') + " MPS details")]) : _vm._e()] : [_c('span', [_vm._v(" ")])], _vm._v(" "), (_vm.temparr.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])])])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedAWB.length > 0),
      expression: "selectedAWB.length > 0"
    }],
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[3]),
      expression: "accordianTab[3]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "FTC Cash Memo",
      "id": "chck3"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[3]) ? _vm._i(_vm.accordianTab[3], null) > -1 : (_vm.accordianTab[3])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(3)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[3] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[3] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 3, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck3"
    }
  }, [_vm._v("FTC Cash Memo")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "disabled": _vm.selectedRemoveAWB.length == 0,
      "type": "button"
    },
    on: {
      "click": _vm.PrintCashMemo
    }
  }, [_vm._v("Print Cash Memo")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', [_c('div', {
    staticStyle: {
      "overflow-y": "auto",
      "max-height": "400px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isAllAddedSelected),
      expression: "isAllAddedSelected"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isAllAddedSelected) ? _vm._i(_vm.isAllAddedSelected, null) > -1 : (_vm.isAllAddedSelected)
    },
    on: {
      "click": _vm.selectAllAdded,
      "__c": function($event) {
        var $$a = _vm.isAllAddedSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isAllAddedSelected = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isAllAddedSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isAllAddedSelected = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr enabled"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])])])]), _vm._v(" "), _c('th', [_vm._v("AWB")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.selectedAWB), function(data) {
    return [_c('tr', {
      staticClass: "text-primary",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedRemoveAWB),
        expression: "selectedRemoveAWB"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.selectedRemoveAWB) ? _vm._i(_vm.selectedRemoveAWB, data) > -1 : (_vm.selectedRemoveAWB)
      },
      on: {
        "click": _vm.selectRemove,
        "__c": function($event) {
          var $$a = _vm.selectedRemoveAWB,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedRemoveAWB = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selectedRemoveAWB = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedRemoveAWB = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.AWB))])])]
  })], 2)])])])], 1)])])])])], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "xl"
    },
    on: {
      "ok": function($event) {
        _vm.showDepartTrip = false
      }
    },
    model: {
      value: (_vm.showDepartTrip),
      callback: function($$v) {
        _vm.showDepartTrip = $$v
      },
      expression: "showDepartTrip"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Start Trip")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeDepartTrip
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("1. Part B Updated")]), _vm._v("  "), _c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "font-size": "22px"
    }
  }), _c('br'), _vm._v(" "), _c('label', [_vm._v("2. Loading Completed")]), _vm._v("  "), _c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "font-size": "22px"
    }
  }), _c('br'), _vm._v(" "), _c('label', [_vm._v("3. Papers complete")]), _vm._v("  "), _c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "font-size": "22px"
    }
  }), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v(" Start Trip : Success!!")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "float": "right",
      "margin-right": "3px"
    }
  }, [_c('button', {
    staticClass: "-btn btn-primary1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeDepartTrip
    }
  }, [_vm._v("Close")])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.showGenerateTrip = false
      }
    },
    model: {
      value: (_vm.showGenerateTrip),
      callback: function($$v) {
        _vm.showGenerateTrip = $$v
      },
      expression: "showGenerateTrip"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.loader
    },
    on: {
      "update:active": function($event) {
        _vm.loader = $event
      }
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Trip Sheet")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeGenerateTripSheet
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_c('b', [_vm._v("Trip Sheet ID")])]), _vm._v(" : " + _vm._s(_vm.parentOBJ.tmstripid) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_c('b', [_vm._v("Vehicle:")])]), _vm._v(" " + _vm._s(_vm.parentOBJ.vehicleNumber) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_c('b', [_vm._v("Vehicle Start ODO reading:")])]), _vm._v(" " + _vm._s(_vm.vehicleODOReading) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-primary1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ShowTripSheetPdf
    }
  }, [_vm._v("Print")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_c('b', [_vm._v("Trip Assigned To:")])]), _vm._v(" " + _vm._s(_vm.parentOBJ.userType) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_c('b', [_vm._v("BA/SR Name: ")])]), _vm._v(" " + _vm._s(_vm.parentOBJ.srUser) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_c('b', [_vm._v("Trip Tags:")])]), _vm._v(" " + _vm._s(_vm.isdth == 1 ? 'DTH' : 'Standard') + "\n              ")])]), _vm._v(" "), _c('div', [(_vm.showTripShipment) ? _c('trip-shipment', {
    attrs: {
      "parentOBJ": _vm.parentOBJ
    }
  }) : _vm._e()], 1)])])], 1), _vm._v(" "), (_vm.showtripsheetpdf) ? _c('trip-sheet-pdf', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "tripsheetdata": _vm.tripsheetdata
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.showMPS = false
      }
    },
    model: {
      value: (_vm.showMPS),
      callback: function($$v) {
        _vm.showMPS = $$v
      },
      expression: "showMPS"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("View MPS")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.showMPS = false
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('th', [_vm._v("Sr.No")]), _vm._v(" "), _c('th', [_vm._v("MPS")]), _vm._v(" "), _c('th', [_vm._v("AWB")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("MPS Physical Weight(kg)")]), _vm._v(" "), _c('th', [_vm._v("Scanned Status(Y or N)")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.modalData), function(data, index) {
    return [_c('tr', {
      class: {
        'rowtype1': data.mpsscanned,
        'rowtype2': data.ismpsshort || data.isdeps
      },
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.mps))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awb))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.clientname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.totalphysicalwt))]), _vm._v(" "), (data.mpsscanned) ? _c('td', [_vm._v("Y")]) : _vm._e(), _vm._v(" "), (!data.mpsscanned) ? _c('td', [_vm._v("N")]) : _vm._e()])]
  })], 2)])])])])], 1), _vm._v(" "), (_vm.closeTrip == true) ? _c('div', [_c('deps-start-trip', {
    attrs: {
      "parentObj": _vm.startTripObj
    },
    on: {
      "goBackToParent": _vm.callParent
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isMultiPrint) ? _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    attrs: {
      "id": "printCashMemoData"
    }
  }, _vm._l((_vm.printAwbs), function(item) {
    return _c('FTCMemoDepositSlip', {
      key: item.AWB,
      attrs: {
        "selectedData": item
      }
    })
  }))]) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5313fbc6","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/TripManagement/CreateTripManagement/startTrip/startTrip.component.html
// module id = 1360
// module chunks = 3